export default "/images/vendor/flag-icon-css/flags/4x3/pf.svg?60eab759c4bdba38ab46cc3bfe75766e";